import React from "react";
import axios from "axios";
import Costanti from "../../constantiX";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column, InputText, Dialog, InputTextarea, Toast, Dropdown } from "primereact";
import { Formik } from "formik";
import * as Yup from "yup";

import "../../assets/css/badge.css";

class ListaProduzioni extends React.Component {
  constructor() {
    super();
    this.actions = [
      {
        id: 1,
        icon: "pi-search",
        label: "",
        action: (id) => {
          this.vai(id, "V");
          console.log("View " + id);
        },
      },
      {
        id: 2,
        icon: "pi-pencil",
        label: "",
        action: (id) => {
          this.vai(id, "U");
          console.log("Update " + id);
        },
      },
      {
        id: 3,
        icon: "pi-trash",
        label: "",
        action: (id) => {
          this.vai(id, "D");
          console.log("Delete " + id);
        },
      },
    ];
    this.token = sessionStorage.getItem("ICEtoken");
    this.utente = JSON.parse(sessionStorage.getItem("utente"));
    this.state = {
      xcarica: "sezione",
      imgsrc: "",
      activePage: 1,
      processi: [],
      produzioni: [],
      singolo: {},
      totalRecords: 0,
      pageSize: 10,
      first: 0,
      rows: 10,
      visible1: false,
      visible2: false,
      visible3: false,
      loading: true,
    };
    this.onPage = this.onPage.bind(this);
    this.prodottoid = 0;
    this.aziendaid = 0;
    this.produzioneid = 0;
    this.hasImage = "";
    this.hasImageProcesso = "";
  }
  componentDidMount() {
    this.aziendaid = this.utente.aziendaid;
    this.prodottoid = this.props.prodottoid == undefined ? -1 : this.props.prodottoid;
    this.caricaDati(1, this.state.pageSize);
    this.stato = this.props.stato;
  }

  settaImg() {
    var testo =
      Costanti.UrlCallApi +
      "file/get/" +
      this.utente.aziendaid +
      "/produzione/" +
      this.produzioneid +
      "?" +
      Math.random();
    this.setState({ imgsrc: testo });
  }

  showMessage(tipo, messageError, dettaglio) {
    var icona = "";
    if (tipo == "error") {
      icona = "pi pi-times-circle";
    }
    if (tipo == "info") {
      icona = "pipi-info-circle";
    }
    if (tipo == "success") {
      icona = "pi pi-check-circle";
    }
    if (tipo == "warning") {
      icona = "pi pi-exclamation-triangle";
    }
    this.toastBC.show({
      severity: tipo,
      life: 3000,
      closable: false,
      content: (
        <div className="flex flex-column" style={{ flex: "1" }}>
          <div className="text-center">
            <i className={icona} style={{ fontSize: "3rem" }}></i>
            <h4>{messageError}</h4>
            <h5>{dettaglio}</h5>
          </div>
        </div>
      ),
    });
  }

  caricaDati(pagina, numrec) {
    let config = {
      headers: {
        Authorization: "Bearer " + this.token,
      },
    };
    this.setState({ loading: true });
    var quer = "page=" + pagina + "&num=" + numrec + "&aziendaid=" + this.aziendaid + "&prodottoid=" + this.prodottoid;
    axios
      .get(Costanti.UrlCallApi + "produzione/all?" + quer, config)
      .then((res) => {
        res.data.lista1.forEach((element) => {
          element.azioni = this.actions;
        });
        axios
          .get(Costanti.UrlCallApi + "processo/all?page=1&num=10000&aziendaid=" + this.aziendaid, config)
          .then((res) => {
            this.setState({ processi: res.data.lista1, loading: false });
          })
          .catch((error) => {
            alert(error);
          });
        axios
          .get(Costanti.UrlCallApi + "stabilimento/all?page=1&num=10000&aziendaid=" + this.aziendaid, config)
          .then((res) => {
            this.setState({ stabilimenti: res.data.lista1, loading: false });
          })
          .catch((error) => {
            alert(error);
          });
        this.setState({ produzioni: res.data.lista1, totalRecords: res.data.conta1, loading: false });

        //alert(JSON.stringify(this.state.prodotti))
      })
      .catch((error) => {
        alert(error);
      });
  }

  caricaSingolo(id, tipo) {
    let config = {
      headers: {
        Authorization: "Bearer " + this.token,
      },
    };
    this.setState({ loading: true });
    axios
      .get(Costanti.UrlCallApi + "produzione/" + id, config)
      .then((res) => {
        this.setState({ singolo: res.data, loading: false });
        this.produzioneid = id;
        this.hasImage = res.data.hasImage;
        this.hasImageProcesso = res.data.hasImageProcesso;
        this.settaImg();

        this.setImageProcesso(res.data.processoid);
      })
      .catch((error) => {
        this.produzioneid = 0;
        alert(error);
      });
  }

  onPage(event) {
    this.setState({
      loading: true,
      activePage: event.page + 1,
      first: event.first,
    });
    this.caricaDati(event.page + 1, this.state.pageSize);
  }
  setVisible1(val) {
    this.setState({ visible1: val });
    //this.caricaDati(this.state.activePage, this.state.pageSize);
  }

  vai(id, tipo) {
    if (id > 0) this.caricaSingolo(id);
    this.setVisible1(true);
    this.setState({ tipo: tipo });
    switch (tipo) {
      case "A":
        this.setState({ editMode: true, singolo: {}, intestazione: "Aggiungi Produzione" });
        break;
      case "V":
        this.setState({ intestazione: "Visualizza Produzione" });
        break;
      case "D":
        this.setState({ intestazione: "Elimina Produzione" });
        break;
      case "U":
        this.setState({ editMode: true, intestazione: "Modifica Produzione" });
        break;
    }
  }

  async salva(values) {
    try {
      let config = {
        headers: {
          Authorization: "Bearer " + this.token,
        },
      };
      this.setState({ isSubmitting: true });

      if (this.state.tipo == "U") {
        await axios.post(Costanti.UrlCallApi + "produzione/salva/" + this.state.singolo.id, values, config);
      }
      if (this.state.tipo == "D") {
        values.status = "E";
        await axios.post(Costanti.UrlCallApi + "produzione/salva/" + this.state.singolo.id, values, config);
      }
      if (this.state.tipo == "A") {
        var dato = {
          datains: null,
          dataupd: null,
          id: 0,
          prodottoid: this.prodottoid,
          processoid: values.processoid,
          stabilimentoid: values.stabilimentoid,

          uteins: 1,
          uteupd: null,
          aziendaid: this.aziendaid,
          status: " ",
        };
        await axios.post(Costanti.UrlCallApi + "produzione/aggiungi", dato, config);
      }
      this.showMessage("success", "Dati salvati correttamente", "");

      this.setVisible1(false);
      this.caricaDati(this.state.activePage, this.state.pageSize);
    } catch (error) {
      this.showMessage("error", "Errore nel salvataggio", error.message);
      this.setState({ isSubmitting: false });
    }
  }

  setPDF(value) {
    let config = {
      headers: {
        Authorization: "Bearer " + this.token,
      },
    };
    axios
      .get(Costanti.UrlCallApi + "stampe/produzioni/" + this.aziendaid, config)
      .then((res) => {
        const link = document.createElement("a");
        const url = Costanti.UrlCallApi + "file/getFile/" + res.data;

        link.href = url;
        link.setAttribute("download", res.data);
        // Append to html link element page
        document.body.appendChild(link);
        // Start download
        link.click();
        // Clean up and remove the link
        link.parentNode.removeChild(link);
      })
      .catch((error) => {
        this.showMessage("error", "Errore nella stampa", error.message);
        this.setState({ isSubmitting: false });
      });
  }

  getProcesso(id) {
    const paramObj = { codiceesterno: "", descrizione: "" };
    this.state.processi.forEach((element) => {
      if (element.id == id) {
        const traduzione = element.traduzione;
        const descrizione = traduzione.find((el) => el.nomecampo === "descrizione" && el.lingua === "it");
        paramObj.codiceesterno = element.codiceesterno;
        paramObj.descrizione = descrizione?.testo;
      }
    });
    return paramObj;
  }

  setImageProcesso(id) {
    if (id) {
      var testo = Costanti.UrlCallApi + "file/get/" + this.utente.aziendaid + "/processo/" + id + "?" + Math.random();
      this.setState({ imgsrcProcesso: testo });
    }
  }

  validationSchema() {
    return Yup.object().shape({
      stabilimentoid: Yup.string().required("Stabilimento obbligatorio").typeError("Stabilimento obbligatorio"),
      processoid: Yup.string().required("Processo obbligatorio").typeError("Processo obbligatorio"),
      descrizione: Yup.string().required("descrizione obbligatoria").typeError("descrizione obbligatoria"),
    });
  }
  render() {
    console.log(this.state.tipo);
    return (
      <div>
        <Toast ref={(el) => (this.toastBC = el)} position="bottom-center" />

        <Dialog
          header="PDF"
          closable={false}
          visible={this.state.viewPDF}
          modal
          breakpoints={{ "960px": "75vw", "640px": "100vw" }}
          style={{ width: "40vw" }}
          draggable={false}
          resizable={false}
        >
          <footer>
            <div className="border-top-1 surface-border pt-3">
              <Button type="button" icon="pi pi-check" onClick={() => this.setPDF(false)} label="Chiudi" />
            </div>
          </footer>
        </Dialog>

        <Dialog
          header="PDF"
          closable={false}
          visible={this.state.viewPDF}
          modal
          breakpoints={{ "960px": "75vw", "640px": "100vw" }}
          style={{ width: "40vw" }}
          draggable={false}
          resizable={false}
        >
          <footer>
            <div className="border-top-1 surface-border pt-3">
              <Button type="button" icon="pi pi-check" onClick={() => this.setPDF(false)} label="Chiudi" />
            </div>
          </footer>
        </Dialog>
        <DataTable
          emptyMessage={<div className="flex w-full justify-content-center font-bold ">NO DATA FOUND</div>}
          value={this.state.produzioni}
          rows={this.state.pageSize}
          totalRecords={this.state.totalRecords}
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks CurrentPageReport NextPageLink LastPageLink"
          currentPageReportTemplate="	(pag. {currentPage} di {totalPages}) "
          paginator={true}
          onPage={this.onPage}
          loading={this.state.loading}
          lazy={true}
          first={this.state.first}
          header={
            <div className="mb-1 flex align-items-center justify-content-between">
              <span className="text-xl font-medium text-900">Lista Produzioni</span>
              <InputText type="search" className="border-none" placeholder="Cerca..." />

              {this.stato == "U" ? (
                <>
                  {/*<Button label="Esporta in Pdf" onClick={()=>this.setPDF(true)}   icon="pi pi-file-pdf" className="p-button-rounded p-button-danger "/> */}
                  {this.prodottoid > 0 && (
                    <Button
                      label="Aggiungi"
                      onClick={() => this.vai(0, "A")}
                      icon="pi pi-plus"
                      className="p-button-rounded p-button-primary "
                    />
                  )}
                </>
              ) : (
                ""
              )}
            </div>
          }
          responsiveLayout="stack"
        >
          <Column id="id1" header="Processo" body={(item) => this.getProcesso(item.processoid).codiceesterno} />

          <Column id="id1a" field="descStabilimento" header="Stabilimento" />
          <Column
            id="id3"
            field="descrizione"
            header="Descrizione"
            body={(item) => this.getProcesso(item.processoid).descrizione}
          />

          <Column
            id="id5"
            field="id"
            header="Azioni"
            body={(item) => (
              <div className="product-list-action flex" style={{ alignItems: "center", gap: "1rem" }}>
                {this.actions.map((action) => (
                  <Button
                    key={action.id}
                    className="p-button-sm"
                    icon={`pi ${action.icon}`}
                    label={action.label}
                    aria-label={action.label}
                    onClick={(e) => {
                      e.stopPropagation();
                      action.action(item.id);
                    }}
                  />
                ))}
              </div>
            )}
          ></Column>
        </DataTable>
        <Dialog
          header={this.state.intestazione}
          closable={false}
          visible={this.state.visible1}
          modal
          breakpoints={{ "960px": "75vw", "640px": "100vw" }}
          style={{ width: "60%" }}
          draggable={false}
          resizable={false}
        >
          <div className="flex flex-wrap border-top-1 surface-border pt-4">
            <div className="surface-card p-2  border-round">
              <Formik
                initialValues={{
                  processoid: this.state.singolo.processoid,
                  stabilimentoid: this.state.singolo.stabilimentoid,
                  status: this.state.singolo.status,
                  descrizione: this.getProcesso(this.state.singolo.processoid).descrizione,
                }}
                enableReinitialize
                validationSchema={this.validationSchema}
                onSubmit={async (values) => {
                  await this.salva(values);
                }}
              >
                {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
                  <form onSubmit={handleSubmit}>
                    <div className="grid formgrid p-fluid">
                      <div className="flex flex-column    surface-border border-top-1 opacity-50 mb-3 col-12"></div>

                      <div className="field mb-1 col-12 md:col-12 mb-2">
                        <label htmlFor="processoid" className="font-medium text-600">
                          Processo
                        </label>
                        <Dropdown
                          disabled={this.state.tipo === "V" || this.state.tipo === "D"}
                          optionLabel="codiceesterno"
                          options={this.state.processi}
                          optionValue="id"
                          value={values.processoid}
                          onChange={(e) => {
                            setFieldValue("processoid", e.value),
                              setFieldValue("descrizione", this.getProcesso(e.value).descrizione);
                            this.setImageProcesso(e.value);
                          }}
                          placeholder="Seleziona processo"
                        />

                        <div style={{ color: "red" }}>
                          {errors.processoid && touched.processoid && errors.processoid}
                        </div>
                      </div>
                      <div className="field mb-1 col-12 md:col-12 mb-2">
                        <label htmlFor="stabilimentotoid" className="font-medium text-600">
                          Stabilimento
                        </label>
                        <Dropdown
                          disabled={this.state.tipo === "V" || this.state.tipo === "D"}
                          optionLabel="nome"
                          options={this.state.stabilimenti}
                          optionValue="id"
                          value={values.stabilimentoid}
                          onChange={(e) => {
                            setFieldValue("stabilimentoid", e.value);
                          }}
                          placeholder="Seleziona Stabilimento"
                        />
                        <div style={{ color: "red" }}>
                          {errors.stabilimentoid && touched.stabilimentoid && errors.stabilimentoid}
                        </div>
                      </div>
                      <div className="field mb-1 col-12 md:col-12 mb-2">
                        <label htmlFor="nome" className="font-medium text-600">
                          Descrizione
                        </label>
                        <InputTextarea
                          readOnly={true}
                          name="descrizione"
                          rows={3}
                          value={values.descrizione}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          type="text"
                          style={{ resize: "none" }}
                        />
                      </div>
                    </div>

                    <footer>
                      <div className="flex flex-row gap-2 border-top-1 surface-border pt-3">
                        <Button type="submit" visible={this.state.tipo == "U"} icon="pi pi-save" label="Salva" />
                        <Button visible={this.state.tipo == "A"} icon="pi pi-save" label="Aggiungi" />
                        <Button
                          visible={this.state.tipo == "D"}
                          icon="pi pi-trush"
                          label="Elimina"
                          className="p-button-outlined p-button-danger "
                        />
                        <Button
                          type="button"
                          onClick={() => this.setVisible1(false)}
                          label="Chiudi"
                          className="p-button-outlined "
                        />
                      </div>
                    </footer>
                  </form>
                )}
              </Formik>
            </div>
          </div>
        </Dialog>
      </div>
    );
  }
}

export default ListaProduzioni;
